import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import _ from 'lodash';

/* Actions */
import {
	getOthersUserDetails,
	getOthersApprovedAccounts,
	getOthersLocalUserDetails
} from '../../../redux/actions';
import ProfileTabs from './ProfileTabs';

class ManageUsersPage2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userDetails: null,
			approvedAccounts: null,
			localUserDetails: null,
        }
    }

	componentWillMount() {
		const { userDetails } = this.props.state.user;
		if(!this.props.isEmployeeHasAccessTo('Manage Users') && !(userDetails && userDetails.typeOfUser === "customer" && userDetails.isAdmin)) {
			browserHistory.push("/profile/myProfile");
		}
	}

    componentDidMount() {
		const self = this;
		const sso = self.props.params.sso;
		self.props.getOthersUserDetails(`userId=${sso}&requestType=getUserDetails`, resp => {
			if(resp.status && resp.responseObject && resp.responseObject.length > 0) {
				self.setState({
					userDetails: resp.responseObject[0]
				});
				// Make second service call with PERSON_PARTY_ID
				self.props.getOthersApprovedAccounts(`personPartyId=${resp.responseObject[0].PERSON_PARTY_ID}&requestType=getUserAccounts`, response => {
					response.responseObject = response.responseObject ? response.responseObject.filter(item => item.RELATIONSHIP_STATUS === 'A' && item.ACCT_ROLE_STATUS === 'A') : [];
					// service will return approved account
					if(response.status && response.responseObject) {
						self.setState({
							approvedAccounts: response.responseObject
						})
					}
				});
				// get local user details
				self.props.getOthersLocalUserDetails(`userId=${sso}&requestType=getLocalUser`, response => {
					if(response.status) {
						if(response.responseObject) {
							self.setState({
								localUserDetails: response
							})
						}
					}
				});
			} else {
				browserHistory.push('/error');
			}
		});
    }

    render() {
        const { userDetails, approvedAccounts, localUserDetails } = this.state;
        return (
            <div>
				<ProfileTabs isEmployeeHasAccessTo={this.props.isEmployeeHasAccessTo} selectedTab='manageUsers' />
                <p className="push">
					<Link className="bold" to="/profile/manageUsers">&lt; Return to User List</Link>
				</p>
                {userDetails &&
						<div className="push">
	                    <h2 className="unbold">
	                        <b>User Name:</b>&nbsp;{this.props.params.sso}
	                        &nbsp;
	                        &nbsp;
	                        &nbsp;
	                        &nbsp;
	                        <b>Email:</b>
	                        &nbsp;
	                        {userDetails.EMAIL_ADDRESS}
	                    </h2>
	                </div>
				}
                {approvedAccounts &&
	                <div className="push">
	                    <h3>The user listed above has access to the following accounts:</h3>
	                    <hr />
	                  {approvedAccounts.slice().sort(function(a, b) {  return +a.ACCOUNTNUMBER - +b.ACCOUNTNUMBER; }).map((item, index)=>{
	                        if(item.STATUS === "A") {
								let isAdmin = false;
								if(localUserDetails && localUserDetails.responseObject && localUserDetails.responseObject.accounts) {
									const result = _.find(localUserDetails.responseObject.accounts, ['accountNumber', item.ACCOUNTNUMBER]);
									isAdmin = result && result.admin === "Y" ? true : false;
								}
		                        return <p key={index}>
		                            {item.ACCOUNTNUMBER}&nbsp;— {item.ACCOUNTDESCRIPTION}
		                            {isAdmin ? <span className="orange">&nbsp;(Account Administrator)</span> : null}
		                        </p>
							} else return null;
	                    })}
	                </div>
				}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOthersUserDetails: (payload, callback) => dispatch(getOthersUserDetails(payload, callback)),
	getOthersApprovedAccounts: (payload, callback) => dispatch(getOthersApprovedAccounts(payload, callback)),
	getOthersLocalUserDetails: (payload, callback) => dispatch(getOthersLocalUserDetails(payload, callback)),
});

ManageUsersPage2 = connect(mapStateToProps, mapDispatchToProps)(ManageUsersPage2);
export default ManageUsersPage2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/ManageUsersPage2.js